import * as _ from 'lodash/fp';

export enum SidebarTab {
    variantsTab = 'Slicer',
    filtersTab = 'Filters',
    discoveryTab = 'Discovery',
    settingsTab = 'Settings',
}

export const SidebarTabs = _.values(SidebarTab);

export enum ActivityTableLabel {
    Activity = 'Activity',
};

export const ActivityTableLabels = _.values(ActivityTableLabel);

export enum ShowLabel {
    loops = 'Loops',
    compliant = 'Compliant'
}

export const ShowLabels = _.values(ShowLabel);

export enum TableLabel {
    from_activity = 'From Activity',
    to_activity = 'To Activity',
    tasks = 'Tasks',
    avg_duration = 'Avg Duration',
    std_deviation = 'Std Deviation',
    loop = 'Loop',
    compliant = 'Compliant',
}

export const TableLabels = _.values(TableLabel);

export enum AttributeTableLabel {
    value = 'Value',
    tasks = 'Tasks',
    perc_total = '% Total',
}

export const AttributeTableLabels = _.values(AttributeTableLabel);

export enum ResourceTableLabel {
    resource = 'Resource',
    tasks = 'Tasks',
    avgDuration = 'Avg Duration',
}

export const ResourceTableLabels = _.values(ResourceTableLabel);

export enum SpGaugeLabel {
    step = 'Step',
    task = 'Task',
    variant = 'Variant',
}

export const SpGaugeLabels = _.values(SpGaugeLabel);
